import { resolveBatchPlanningStartDateForLeadWeeks } from "../planning-lead-time"
import { formatDateOnly } from "../dates"
import { DEFAULT_ORGANIZATION_TIMEZONE } from "../../../../_shared/_logic/timezones"

export type PlanningStartPreset = "in_1_week" | "in_2_weeks" | "in_3_weeks" | "custom"

export const defaultPlanningStartPreset = (): PlanningStartPreset => "in_2_weeks"

const planningStartPresets: Array<{ label: string; value: PlanningStartPreset }> = [
  { label: "1 volle Vorlaufwoche", value: "in_1_week" },
  { label: "2 volle Vorlaufwochen", value: "in_2_weeks" },
  { label: "3 volle Vorlaufwochen", value: "in_3_weeks" },
  { label: "Individuelles Startdatum", value: "custom" },
]

export const planningStartPresetOptions = (
  now = new Date(),
  timezone = DEFAULT_ORGANIZATION_TIMEZONE,
): Array<{ label: string; value: PlanningStartPreset; startDate: string | null }> =>
  planningStartPresets.map((option) => {
    const startDate = planningStartDateForPreset(option.value, now, timezone)
    const displayDate = startDate?.split("-").reverse().join(".")

    return {
      ...option,
      startDate,
      label: displayDate ? `${option.label} (ab ${displayDate})` : option.label,
    }
  })

const leadWeeksForPreset = (preset: PlanningStartPreset): number | null => {
  if (preset === "in_1_week") return 1

  if (preset === "in_2_weeks") return 2

  if (preset === "in_3_weeks") return 3

  return null
}

export const planningStartDateForPreset = (
  preset: PlanningStartPreset,
  now = new Date(),
  timezone = DEFAULT_ORGANIZATION_TIMEZONE,
): string | null => {
  const leadWeeks = leadWeeksForPreset(preset)

  return leadWeeks === null
    ? null
    : resolveBatchPlanningStartDateForLeadWeeks(leadWeeks, now, timezone)
}

export const planningStartPresetForDate = (
  startDate: string | null | undefined,
  now = new Date(),
  timezone = DEFAULT_ORGANIZATION_TIMEZONE,
): PlanningStartPreset => {
  const normalized = formatDateOnly(startDate)

  if (!normalized) return "custom"

  for (const option of planningStartPresets) {
    const optionDate = planningStartDateForPreset(option.value, now, timezone)

    if (optionDate && optionDate === normalized) return option.value
  }

  return "custom"
}
